export default __webpack_public_path__ + "static/media/mail-outline-16px.46fcde16.svg";